module.exports = __webpack_public_path__ + "a2f25b27a8d0b3498122655c760360fb.png";